import { useEffect } from 'react'
import { NavLink, Outlet } from 'react-router'
import { useBahasa } from '../../app/i18n'
import { useSesi } from '../../app/auth'
import PemilihBahasa from '../../app/PemilihBahasa'
import Merek from '../../shared/ui/Merek'

const cx = (...a) => a.filter(Boolean).join(' ')

const MENU = [
  { ke: '/hari-ini', kunci: 'nav.hariIni' },
  { ke: '/perlu-dijawab', kunci: 'nav.perluDijawab' },
  { ke: '/prospek', kunci: 'nav.prospek' },
  { ke: '/meeting', kunci: 'nav.meeting' },
  { ke: '/konten', kunci: 'nav.konten' },
]

/**
 * Shell Tenant Marketing.
 *
 * Shell memegang navigasi dan tata letak; ia TIDAK memegang data. Penggabungan
 * antar-domain terjadi di sini, bukan di dalam domain — itu aturan yang membuat
 * susunan ini modular monolith dan bukan bola benang (ADR-043).
 */
export default function ShellTenant() {
  const { t } = useBahasa()
  const { sesi, keluar } = useSesi()

  // Aksen warna ditentukan shell. Orang yang membuka lebih dari satu antarmuka
  // harus tahu sedang di mana tanpa membaca judulnya.
  useEffect(() => {
    document.documentElement.dataset.shell = 'tenant-marketing'
    return () => { delete document.documentElement.dataset.shell }
  }, [])

  return (
    <div className="grid min-h-full md:grid-cols-[214px_minmax(0,1fr)]">
      <nav className="bg-surface border-b md:border-b-0 md:border-r border-line flex flex-col gap-5 py-4 md:sticky md:top-0 md:h-screen">
        <Merek antarmuka={t('app.tenantMarketing')} />

        <div className="flex flex-col gap-px">
          {MENU.map((m) => (
            <NavLink
              key={m.ke}
              to={m.ke}
              className={({ isActive }) =>
                cx(
                  'flex items-center justify-between gap-2 px-[18px] py-[7px] text-[13px] border-l-2',
                  isActive
                    ? 'text-ink bg-surface2 border-accent font-semibold'
                    : 'text-ink2 border-transparent font-medium hover:bg-surface2 hover:text-ink',
                )
              }
            >
              {t(m.kunci)}
            </NavLink>
          ))}
        </div>

        <div className="mt-auto px-[18px] flex flex-col gap-2.5">
          <PemilihBahasa />
          <div className="flex items-end justify-between gap-2">
            <div className="min-w-0">
              <b className="block text-[12px] font-semibold truncate">{sesi?.nama}</b>
              {/* Nilai kolomnya kini SAMA dengan yang dibaca orang sejak migrasi
                  0013 — `tenant_admin`, `tenant_marketing`, `smova_admin`. Pemetaan
                  ini tinggal soal huruf besar dan spasi, bukan lagi dua kosakata.
                  Kunci yang tidak dikenal jatuh ke namanya sendiri (lihat i18n.jsx),
                  jadi peran baru akan terlihat salah di layar alih-alih diam. */}
              <span className="text-[11px] text-ink3">
                {t(`peran.${sesi?.peran}`)}
              </span>
            </div>
            <button
              onClick={keluar}
              className="text-[11px] text-ink3 hover:text-ink underline bg-transparent border-0 cursor-pointer p-0"
            >
              {t('umum.keluar')}
            </button>
          </div>
        </div>
      </nav>

      <main className="min-w-0">
        <div className="p-6 max-w-[1240px] w-full flex flex-col gap-5">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
